/* global axios */
// NOTICE: KAPTION-INTEGRATION
// embedded-channel.DASHBOARD.1-5: admin API of the Embedded channel (a web widget
// inbox plus its embedded_channels row). Every call is administrator-only and
// gated server-side by KAPTION_EMBEDDED_CHANNEL, except the Studio token, which
// works for any web widget inbox.

const accountBase = accountId => `/api/v1/accounts/${accountId}`;
const inboxBase = (accountId, inboxId) =>
  `${accountBase(accountId)}/inboxes/${inboxId}`;

export const KaptionEmbeddedAPI = {
  // embedded-channel.DASHBOARD.2: web widget + inbox + embedded_channels row in one call.
  createInbox(accountId, params) {
    return axios.post(`${accountBase(accountId)}/embedded_inboxes`, params);
  },

  getChannel(accountId, inboxId) {
    return axios.get(`${inboxBase(accountId, inboxId)}/embedded_channel`);
  },
  // embedded-channel.OPTIN.1: opt a plain web widget in.
  enable(accountId, inboxId) {
    return axios.post(`${inboxBase(accountId, inboxId)}/embedded_channel`);
  },
  // embedded-channel.CONTINUITY.5: identity_mode, legacy_identifier_hash, continuity_mode.
  // rumo-sdk-backend.IDENTITY.6: switching to open needs `{ confirm: 'open' }`
  // at the top level of the body, passed as `extra`.
  updateChannel(accountId, inboxId, embeddedChannel, extra = {}) {
    return axios.patch(`${inboxBase(accountId, inboxId)}/embedded_channel`, {
      embedded_channel: embeddedChannel,
      ...extra,
    });
  },
  // embedded-channel.OPTIN.2: back to a plain web widget.
  disable(accountId, inboxId) {
    return axios.delete(`${inboxBase(accountId, inboxId)}/embedded_channel`);
  },
  revealSecret(accountId, inboxId) {
    return axios.post(
      `${inboxBase(accountId, inboxId)}/embedded_channel/reveal_secret`
    );
  },
  rotateSecret(accountId, inboxId) {
    return axios.post(
      `${inboxBase(accountId, inboxId)}/embedded_channel/rotate_secret`
    );
  },

  listApps(accountId, inboxId) {
    return axios.get(`${inboxBase(accountId, inboxId)}/embedded_apps`);
  },
  createApp(accountId, inboxId, embeddedApp) {
    return axios.post(`${inboxBase(accountId, inboxId)}/embedded_apps`, {
      embedded_app: embeddedApp,
    });
  },
  deleteApp(accountId, inboxId, appId) {
    return axios.delete(
      `${inboxBase(accountId, inboxId)}/embedded_apps/${appId}`
    );
  },
  testPush(accountId, inboxId, appId) {
    return axios.post(
      `${inboxBase(accountId, inboxId)}/embedded_apps/${appId}/test_push`
    );
  },
  rotateRelaySecret(accountId, inboxId, appId) {
    return axios.post(
      `${inboxBase(accountId, inboxId)}/embedded_apps/${appId}/rotate_relay_secret`
    );
  },

  // rumo-web-widget.STUDIO.1: Widget Studio for any web widget inbox, Embedded or not.
  studioToken(accountId, inboxId) {
    return axios.post(
      `${inboxBase(accountId, inboxId)}/embedded_configuration/studio_token`
    );
  },
};

export default KaptionEmbeddedAPI;
